module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-46.fb5a2ba2.png";